import { Space } from 'component/Space'
import { useEffectOnce } from 'hook/useEffectOnce'
import { observer } from 'mobx-react-lite'
import { InferencesView } from 'page/Fullscreen/Inferences/InferencesView'
import { RecommendationsView } from 'page/Fullscreen/Recommendations/RecommendationsView'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './Fullscreen.module.scss'

export const Fullscreen = observer(() => {
  const { inferences, recommendations } = store.fullscreen ?? {}

  useEffectOnce(() => {
    function listener(event: KeyboardEvent) {
      if (event.key === 'Escape') controller.closeFullscreen()
    }

    document.addEventListener('keydown', listener)
    return () => document.removeEventListener('keydown', listener)
  })

  if (!store.fullscreen) return null

  return <Space className={css.fullscreen} center>
    {inferences && <InferencesView carousel={inferences} />}
    {recommendations && <RecommendationsView carousel={recommendations} />}
  </Space>
})
